export { MarketingOptIn } from './MarketingOptIn';
